export const EProcessoSituacao = {
    INATIVO: 0,
    ATIVO: 1,
}

export const ETipoPermissao = {
    LEITURA: 1,
    PREENCHER_CHECKLIST: 2,
    ESCREVER: 3,
    CRIAR_DIRETORIO: 4,
    CRIAR_PROCESSOS_CHECKLISTS: 5,
    REVISAR_CHECKLIST: 6,
    GERENCIAR: 90,
    ADMIN: 99,
};

export const EArquivoSituacao = {
    INATIVO: 0,
    ATIVO: 1,
}

export const EDiretorioSituacao = {
    INATIVO: 0,
    ATIVO: 1,
}